/*
 * @Author: your name
 * @Date: 2021-05-18 09:42:33
 * @LastEditTime: 2021-05-18 09:42:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ipublishment-ssr-web/components/ipub-ui/packages/icon/index.js
 */
import IpubForm from './src/main'

/* istanbul ignore next */
IpubForm.install = function(Vue) {
  Vue.component(IpubForm.name, IpubForm)
}

export default IpubForm
